import { Section } from "../../../shared"
import { useContext } from "react"
import { ImplementerProfileContext } from "../../../../contexts/implementer/profile"
import BudgetSummaryTable from "./budgetSummaryTable"



export function BudgetSummary() {
  const {
    loading,
    error,
    data,
    updateGeneralInformation,
    disabled = false
  } = useContext(ImplementerProfileContext)


  const onChange = data => {
    const cleanData = data.map(item => {
    const obj = { ...item };
    delete obj.undefined;
    return obj;
  });
    updateGeneralInformation({ annualBudgets: cleanData })
  }

  return (
    <Section title="3. Resumen de presupuestos anuales">
        <div style={{overflowWrap:"break-word", whiteSpace:"normal", marginBottom:"16px", fontSize:"13px", opacity:"50%"}}>
        Favor de cargar los ingresos por año y estados financieros que la Socia Implementadora ha tenido vigentes en los últimos 2 años de operación y el año actual.<br/>
        Si la socia implementadora tiene varios años trabajando con FICOSEC, deberá incluir información desde los dos años anteriores al inicio de la colaboración con FICOSEC hasta el año actual.
      </div>
      <BudgetSummaryTable
        data={data}
        onChange={onChange}
        isLoading={loading}
        error={error}
        disabled={disabled} />
    </Section>
  )
}
